import script from "./AnalogClock.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalogClock.vue?vue&type=script&setup=true&lang=js"

import "./AnalogClock.vue?vue&type=style&index=0&id=b6ba4414&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ba4414"]])

export default __exports__